import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import { Icon, Divider, Button } from 'components';
import { useTranslation } from 'react-i18next';
import { useKeyPress } from 'hooks/useKeyPress';

interface ModalProps {
    visible: boolean,
    toggle: Function | any,
    title?: string,
    buttons?: string,
    children: React.ReactElement,
    className?: string,
}

export const Modal = ({
    visible,
    toggle,
    title,
    buttons,
    children,
    className,

}: ModalProps) => {
    const { t } = useTranslation();
    const escPress = useKeyPress('Escape');

    useEffect(() => {
        if (escPress && visible && toggle) {
            toggle();
        }
    }, [escPress])


    return visible
        ? ReactDOM.createPortal(
            <div className="fixed top-0 left-0 w-full h-screen z-50">
                <div
                    className={cn(
                        'modal-content absolute top-2/4 left-0 right-0 m-auto bg-white rounded-lg max-w-full w-11/12 md:w-min z-10 overflow-auto',
                        className,
                    )}
                    style={{ transform: 'translateY(-50%)', maxHeight: '95vh' }}
                    role="dialog"
                    aria-modal="true"
                >
                    {children}
                </div>
                <div
                    className="modal-overlay absolute top-0 left-0 w-full h-full backdrop-filter backdrop-blur-sm bg-black bg-opacity-20"
                    onClick={toggle}
                >
                </div>
            </div>, document.body
        ) : null
};